import React, { FunctionComponent, useEffect } from 'react';
import users, { getList } from '@stores/users';
import UsersTable from '@components/UsersTable';
import UserEditModal from '@components/UserEditModal';
import UsersListHeader from '@components/UsersListHeader';
import { getQuery } from '@helpers/navigation';

interface UserListRouteProps {}

const UserListRoute: FunctionComponent<UserListRouteProps> = () => {
  useEffect(() => {
    const query = getQuery();
    const registrationIp =
      typeof query.registrationIp === 'string' ? query.registrationIp : undefined;
    const filterUdid = typeof query.filterUdid === 'string' ? query.filterUdid : undefined;

    getList({
      filters: {
        ...users.getState().filters,
        registrationIp,
        filterUdid,
      },
    });
  }, []);

  return (
    <>
      <UsersListHeader />
      <UsersTable />
      <UserEditModal />
    </>
  );
};

export default UserListRoute;
